import { render } from "./Material.vue?vue&type=template&id=0cafdb7f"
import script from "./Material.vue?vue&type=script&lang=js"
export * from "./Material.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/projects/rde/resources/vueapps/quotation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__